module.exports = "/images/financial-windfall.png?43fb1b16304c59a929904ba9b522aaf4";